<template>
  <b-card
    class="media-card media-card-simple mt-1 mb-2"
    v-bind:class="{
      'media-card-dy': client_name == 'DY',
      'media-card-mid': client_name == 'MID',
    }"
    :title="title"
    :sub-title="duration"
    :img-src="img_src"
    img-alt="Image"
    img-top
    tag="article"
  >
  </b-card>
</template>

<script>
export default {
  name: "SimpleMediaCard",
  props: ["client_name", "title", "duration", "img_src"],
  data() {
    return {};
  },
  mounted() {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/media_components/SimpleMediaCard.vue